<template>
<div class="error-alert-list">
    <el-alert type="error" :closable="false">
        <template v-slot:title>
            <i class="el-icon-error"></i><span class="alert-text">過密状態です</span>
        </template>
        <ul class="attention-box">
            <li v-for="cameraName in errorList" :key="cameraName" class="camera-list">
                <router-link :to="{ path: '/', query: { cameraName: cameraName }}" tag="el-link"><span class="alert-text-list" @click="streamHandler">{{ cameraName }}</span></router-link>
            </li>
        </ul>
    </el-alert>

    <el-alert type="warning" :closable="false">
        <template v-slot:title>
            <i class="el-icon-warning"></i><span class="alert-text">警戒が必要です</span>
        </template>
        <ul class="attention-box">
            <li v-for="cameraName in warningList" :key="cameraName" class="camera-list">
                <router-link :to="{ path: '/', query: { cameraName: cameraName }}" tag="el-link"><span class="alert-text-list" @click="streamHandler">{{ cameraName }}</span></router-link>
            </li>
        </ul>
    </el-alert>

</div>
</template>

<script>
export default {
    data() {
        return {
            alertType: ''
        }    
    },
    
    computed:{
        errorList: function() {
          let cameraList = []
          let densityLevel = ''
          this.$store.state.realtimeData.forEach(stream => {
            
            densityLevel = stream.dataList[3].val
            if (densityLevel === '高') {
              cameraList.push(stream.cameraName)
            }
          })
          return cameraList
        },
        
        warningList: function(){
          let cameraList = []
          let densityLevel = ''
          this.$store.state.realtimeData.forEach(stream => {
            densityLevel = stream.dataList[3].val
            if (densityLevel === '中') {
              cameraList.push(stream.cameraName)
            }
          })
          return cameraList
        },
        
        existsAttentionList: function() {
            
            let msg = ""
            if (this.errorList.length) {
                msg = "danger"
            } else if (this.warningList.length) {
                msg = "warning"
            } else {
                msg = "info"
            }
            this.$emit('manageBadge', msg)
            return msg
        }
    },
    
    methods: {
        streamHandler: function() {
            this.$emit('clickStream')
        }
    },
    
    watch: {
        existsAttentionList: function (val) {
            this.$emit('manageBadge', val)
        }
    }
}
</script>

<style scoped>
    .attention-box {
        height: 120px;
        padding: 0px;
        overflow: auto;
    }
    .camera-list {
        list-style: none;
        padding-bottom: 10px;
    }
    
    .camera-list a{
        font-size: 12px;
    }
    
    .error-alert-list >>> .el-alert__content{
        width: 100%;
    }
    
    @media screen and (max-width: 980px) {
        i.el-icon-error{
            color: #F56C6C;
        }
        
        i.el-icon-warning{
            color: #E6A23C;
        }
        
        .alert-text{
            font-size: 16px;
            font-family: "sans-serif";
            font-weight: bold;
        }
        
        .alert-text-list{
            font-size: 14px;
            font-family: "sans-serif";
            font-weight: normal;
        }
        
        .camera-list {
            list-style: none;
            padding-bottom: 0;
        }
    }
</style>